/** EN uses Swedish values until translated. */
export const pagesIssuesEn = {
    noIssuesFound: 'No issues found',
    details: {
        cancelledPrefix: 'Cancelled:',
        cancelledNotice:
            'Please note that this issue has been cancelled. The content reproduced below reflects the information that was available to the market.',
        announcedNotCompleted:
            'This issue has been announced but has <strong>not yet been flagged as completed.</strong> This may be due to, for example, a general meeting being required or a letter of intent.',
        importantDates: 'Important dates',
        noDatesYet: 'No dates have been provided yet',
        notAvailable: 'N/A',
    },
    publicStatus: {
        statusLabel: 'Status:',
        cancelled: 'Cancelled',
        upcomingMissingTerms: 'Upcoming, terms missing',
        completed: 'Completed',
        btaBtuTrading: 'Trading in BTA/BTU is ongoing',
        subscriptionPeriodEnded: 'Sub period ended',
        subscriptionPeriodOngoing: 'The subscription period ongoing',
        upcoming: 'Upcoming',
        ongoing: 'Ongoing',
        announced: 'Announced',
        upcomingMissingTermsLong: 'Upcoming share issue. No final terms provided',
        subscriptionPeriodEndedWithOutcome: 'Subscription period ended and the outcome has been announced',
        subscriptionPeriodEndedWithBtaBtu: '. Trading in BTA/BTU is ongoing',
        subscriptionPeriodOngoingWithRightsEnd: 'Subscription period ongoing. Last day for trading rights is {{date}}',
        publishedRightsDeadlinePassed: 'Announced rights issue. Last day to receive rights was {{date}}',
        upcomingRightsDeadline: 'Upcoming share issues. Last day to receive rights is {{date}}',
        upcomingMissingDates: 'Upcoming share issue. Dates missing.',
        completedOnDate: 'Completed: {{date}}',
        announcedWithMeeting: 'Announced share issue, general meeting {{date}}',
        announcedIssue: 'Announced share issue',
        subscriptionPeriodOngoingShort: 'Subscription period ongoing',
    },
    info: {
        title: 'Information',
        loadingTitle: 'Info',
        marketplace: 'Marketplace',
        financialAdvisors: 'Financial advisor',
        legalAdvisors: 'Legal advisor',
        issuingAgent: 'Issuing agent',
    },
    comments: {
        title: 'Other',
        sources: 'Sources',
        isinRights: 'ISIN Subscription rights',
        earnoutDescription: 'The share issue refers to earnout',
        ownSharesDescription:
            'The transaction was carried out with the company’s existing shares instead of issuing new ones.',
        guarantorFeeSourceType: 'Guarantor fee',
    },
    related: {
        relatedIssues: 'Related share issues',
        relatedConvertibles: 'Related convertibles',
    },
    sellers: {
        title: 'Selling owners',
        owner: 'Owner',
    },
    summary: {
        title: 'Summary',
        subscriptionPeriodMissing: 'Sub period missing',
        amountMissing: 'Amount missing',
        subscriptionPeriod: 'Subscription period',
        publicationDate: 'Publication date',
        notCommunicatedYet: 'Not communicated yet',
        outcomeExpectedDate: 'Estimated date {{date}}',
        estimatedDateMissing: 'Estimated date missing',
        issueLabel: 'Share issue',
        issueSize: 'Size of offering',
    },
    underwriters: {
        title: 'Sub commitment and guarantors',
        commitmentInfoNotCommunicated: 'Information about commitments has not yet been communicated.',
        guarantorCompensations: 'Guarantor fees:',
        noCommitment: 'Subscription commitment and guarantors  missing',
    },
    compensation: {
        title: 'Guarantor fees',
        sharesCount: '{{count}} shares',
    },
    investors: {
        title: 'Investors',
        incompleteInfo:
            'Complete information regarding participants and amounts has not been communicated by the company.',
        amountWithCurrency: 'Amount ({{currency}})',
        share: 'Ratio',
        leo: 'LEO',
        yes: 'Yes',
    },
    filters: {
        abbAll: 'All directed issues',
        abbOnly: 'Only ABB',
        abbExclude: 'Exclude ABB',
        warrantsAll: 'All issues',
        warrantsOnly: 'Issues with warrant',
        warrantsExclude: 'Issues without warrant',
        guarantorsAll: 'All share issues',
        guarantorsOnly: 'Issues with guarantors',
        guarantorsNone: 'Issues without guarantors',
        issueTermsAll: 'All rights issues',
        issueTermsOnly: 'Sub price provided initially',
        issueTermsNone: 'Sub price missing initially',
        financialAdvisor: 'Financial advisors',
        legalAdvisor: 'Legal advisor',
        preMoney: 'Pre-money',
        offeringSize: 'Size of offering',
        marketplaces: 'Marketplaces',
        unitIssues: 'Unit issues',
        issueTerms: 'Initial terms',
        guarantors: 'Guarantors',
        bookBuilding: 'Book building',
        marketSizeToday: 'Mcap today',
        marketSizePrePublication: 'Mcap before issue',
    },
    terms: {
        title: 'Terms',
        requestedAmount: 'Amount requested',
        requestedShares: 'Number of shares requested',
        publicationTimestamp: 'Time of publication',
        closingTimestamp: 'Closing time',
        conditions: 'Terms',
        showRightsCalculator: '{{action}} TR calc',
        hide: 'Hide',
        show: 'Show',
        notDeterminedYet: 'Not yet determined',
        termsExplanation: '{{newShares}} {{newSharesLabel}} per {{existingShares}} {{existingSharesLabel}} ({{ratio}})',
        newShare: 'new share',
        newShares: 'new shares',
        existingShare: 'existing',
        existingShares: 'existing',
        subscribeAmount: 'Subscribe',
        payPremium: 'Pay premium',
        premiumTooltip:
            'Calculate the price level of the rights so that they correspond to the specified premium on the subscription price',
        rightsWord: 'rights',
        perRight: '/ right',
        subPrice: 'Sub price',
        subscribedShares: 'Shares subscribed',
        amount: 'Amount',
        warrants: 'Warrants',
        publicationDate: 'Date (publication)',
        outcomeDate: 'Date (completion)',
        conditionalSubscriptionRate: 'Conditional subscription rate',
        conditionalIssueText: 'The issue is conditional on the at least {{rate}} subscription rate',
        warrantsNone: '(None)',
        offeredVolume: 'Offered volume',
        newSharesIssued: 'New shares issued',
        volume: 'Volume',
        noNewSharesIssued: 'No new shares are issued',
        volumeCorresponding: '{{units}}, equivalent to {{shares}}',
        unlistedSharesNote: 'Of which {{quantity}} in the offer refers to unlisted share classes.',
        secondaryOffering: 'Existing shares being sold',
        overAllotment: 'Over-allotment',
        overAllotmentSecondary: 'Over-allotment (existing shares)',
        preMoneyTooltip: 'Pre-money = Subscription price x Number of shares before the issue',
        preMoney: 'Pre-money',
        dilution: 'Dilution',
        dilutionMax: '{{value}} (maximum)',
        dilutionActual: '{{value}} (actual)',
        newSharesMissing: 'Number of new shares missing',
        shareSplit: 'Share split',
        shareSplitForward:
            'Share split on {{date}} where {{oldShares}} {{oldSharesLabel}} is split into {{newShares}} {{newSharesLabel}}',
        shareConsolidation:
            'Merger of shares on {{date}} where {{oldShares}} {{oldSharesLabel}} is merged into {{newShares}} {{newSharesLabel}}',
        share: 'share',
        shares: 'shares',
        bonusIssue: 'Bonus issue',
        bonusIssueDescription:
            'Bonus issue on {{date}} where {{oldShares}} {{oldSharesLabel}} gave {{newShares}} {{newSharesLabel}}',
        existingShareSingular: 'existing share',
        existingSharesPlural: 'existing shares',
        newShareSingular: 'new share',
        newSharesPlural: 'new shares',
        unit: 'Unit',
        warrantsPlaceholder: 'X warrants',
        sharesPlaceholder: 'X shares',
        nonCashConsideration: 'Non-cash consideration',
        units: 'units',
        sharesWord: 'shares',
    },
    discount: {
        label: 'Discount',
        labelWithVwap: 'Discount (10d VWAP)',
        tooltipIntro: 'Discount is calculated from the time the issue was announced.',
        tooltipTerp: 'TERP discount refers to the discount to the theoretical price of the share excluding rights.',
        tooltipFormula:
            'TERP = (Market cap + New shares when fully subscribed * sub price) / (Maximum amount of shares after fully subscribed issue)',
        timePeriod: 'Time period',
        sharePrice: 'Share price',
        discount: 'Discount',
        terp: 'TERP',
        fromPublication: 'Since publication date',
        fromTermsDate: 'Since announced sub price',
        oneDayClose: '{{count}} day close price',
        daysVwap: '{{count}} days VWAP',
        notAvailable: 'Not available',
        vsSharePrice: 'vs share price',
        vsTerp: 'vs TERP',
        cannotCalculate: 'Discounts can not be calculated',
    },
    tradingStats: {
        title: 'Trade statistics',
        notStarted: 'Trading not yet started',
        overview: 'Overall',
        rights: 'Rights',
        timePoint: 'Time',
        vwap: 'VWAP',
        turnoverPerDay: 'Turnover / day ({{currency}})',
        totalQuantity: 'Total number',
        daysBeforePublication: '{{days}}d before publication',
        betweenPublicationAndTerms: 'Between publication and terms',
        duringSubscriptionPeriod: 'During the subscription period',
        duringBtaBtuTrading: 'During trading with BTA/BTU',
        firstTradingDay: 'First trading day',
        firstTradingDays: 'First {{days}} trading days',
        unitTrading: 'Trading in {{symbol}}',
        shareSplitAdjustment:
            'Due to the split carried out during the period, VWAP and Total Number have been adjusted to take the split into account.',
        unitsToSharesNote: '* = Converted from units to shares',
        rightsNotStarted: "Rights haven't started trading yet.",
        rightsStartDate: 'Rights will start trading on {{date}}',
        totalRights: 'Total number of rights',
        approxRightsExclTa: 'Approximate number of rights excluding SC',
        tradedRightsOngoing: 'Traded rights so far',
        tradedRightsTotal: 'Traded rights in total',
        tradedRightsLastDay: 'Traded rights last trading day',
        lastDay: 'Last day: {{date}}',
        rightsVwapTotal: 'Total VWAP of the rights',
        rightsVwapLastDay: 'VWAP of rights on the last trading day',
        ofPricePerShare: 'of the price per new share',
        ofPricePerUnit: 'of the price per unit',
        ofAvailableRights: 'of available rights',
    },
    outcome: {
        title: 'Outcome',
        subscriptionRate: 'subscription rate',
        subscribed: 'Subscribed',
        percent: 'Percentage',
        countUnits: 'Number of units',
        countShares: 'Number of shares',
        amount: 'Amount',
        withRights: 'With rights',
        withoutRights: 'Without rights',
        byGuarantors: 'By guarantors',
        bySubscribers: 'By sub commitments',
        byPublic: 'By the public',
        overAllotment: 'Overallotment',
        chartWithRights: 'Subscribed with rights',
        chartWithoutRights: 'Subscribed without rights',
        chartByGuarantors: 'Sub by guarantors',
        chartNotSubscribed: 'Not subscribed',
        chartBySubscribers: 'Sub by commitments',
        chartByPublic: 'Sub by public',
        totalSubscribed: 'A total amount of {{quantity}} was subscribed for {{amount}}',
        subscriptionRateBreakdown:
            'The subscription rate amounted to {{totalRate}}, of which {{withRightsRate}} of the offering was subscribed with rights and {{withoutRightsRate}} without rights.',
        guarantorsSubscribed:
            'Guarantors subscribed {{pctOfOffer}} of the offer, corresponding to {{pctOfIssued}} of the issued number of shares, or {{pctOfGuaranteed}} of the guaranteed amount.',
        overAllotmentUsed: 'The over-allotment of max {{maxQuantity}} was utilized {{usage}}.',
        overAllotmentSecondaryUsed:
            'The over-allotment of max {{maxQuantity}} existing shares (secondary) was utilized {{usage}}.',
        notUsed: 'not',
        usedTo: 'to {{quantity}}',
        secondaryOfferingUsed:
            'Of the existing {{offered}} that were offered (secondary), {{subscribed}} were subscribed to.',
    },
    feeLevels: {
        subscriber: 'Sub commitment',
        subscription: 'Subscription commitment',
        guarantor: 'Guarantors',
        guarantorCommitment: 'Guarantee commitment',
        bottomGuarantee: 'Bottom guarantors',
        topGuarantee: 'Top guarantors',
        level: 'Level {{level}}',
        subscriptionWithoutRights: 'SC without rights',
        notGuaranteed: 'Not guaranteed',
        totalCommitment: 'Total commitment',
    },
    quantityLabels: {
        right: 'right',
        rights: 'rights',
        share: 'share',
        shares: 'shares',
        unit: 'unit',
        units: 'units',
        warrant: 'warrant',
        warrants: 'warrants',
    },
    subPriceLabel: {
        ipoInterval: '{{low}} - {{high}} {{currency}} / {{label}} ({{interval}})',
        interval: 'interval',
        perLabel: '{{price}} / {{label}}',
        unitWithShareConversion: '{{unitPrice}} / {{unit}}.\n{{equivalent}} {{sharePrice}} / {{share}}.',
        equivalent: 'Equivalent to',
        perShare: '{{price}} per {{share}}',
        perUnit: '{{price}} per {{unit}}',
    },
    shareNameHint: {
        atIpo: 'At the time of the listing, the share was called {{name}}.',
        atIssue: 'At the time of the issue, the share was called {{name}}.',
    },
}
